import { useEffect, useState } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import nysc1 from "../../assets/images/nysc1.jpg"
import nysc2 from "../../assets/images/nysc2.jpg"
import nysc3 from "../../assets/images/nysc3.jpg"
import nysc4 from "../../assets/images/nysc4.jpg"
import nysc5 from "../../assets/images/nysc5.jpg"
import nysc6 from "../../assets/images/nysc6.jpg"
import nysc7 from "../../assets/images/nysc7.jpg"
import nysc8 from "../../assets/images/nysc8.jpg"
import nysc9 from "../../assets/images/nysc9.jpg"
import nysc10 from "../../assets/images/nysc10.jpg"
import nysc11 from "../../assets/images/nysc11.jpg"
import nysc12 from "../../assets/images/nysc12.jpg"
import nysc13 from "../../assets/images/nysc13.jpg"
import nysc14 from "../../assets/images/nysc14.jpg"
import nysc15 from "../../assets/images/nysc15.jpg"
import nysc16 from "../../assets/images/nysc16.jpg"
import nysc17 from "../../assets/images/nysc17.jpg"
import nysc18 from "../../assets/images/nysc18.jpg"

export default function NYSCGallery() {
    const galleryImages = [
        {
            id: 1,
            src: nysc1,

        },
        {
            id: 2,
            src: nysc2,
        },
        {
            id: 3,
            src: nysc3,
        },
        {
            id: 4,
            src: nysc4,
        },
        {
            id: 5,
            src: nysc5,
        },
        {
            id: 6,
            src: nysc6,
        },
        {
            id: 7,
            src: nysc7,

        },
        {
            id: 8,
            src: nysc8,
        },
        {
            id: 9,
            src: nysc9,
        },
        {
            id: 10,
            src: nysc10,
        },
        {
            id: 11,
            src: nysc11,
        },
        {
            id: 12,
            src: nysc12,
        },
        {
            id: 13,
            src: nysc13,
        },
        {
            id: 14,
            src: nysc14,
        },
        {
            id: 15,
            src: nysc15,
        },
        {
            id: 16,
            src: nysc16,
        },
        {
            id: 17,
            src: nysc17,
        },
        {
            id: 18,
            src: nysc18,
        },
    ]

    const IMAGES_PER_VIEW = {
        mobile: 2,
        desktop: 4
    };
    const [startIndex, setStartIndex] = useState(0);
    
    // Determine if we're on mobile using a media query
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Update isMobile state when window resizes
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const imagesPerView = isMobile ? IMAGES_PER_VIEW.mobile : IMAGES_PER_VIEW.desktop;
    const endIndex = startIndex + imagesPerView;
    const visibleImages = galleryImages.slice(startIndex, endIndex);

    const prevImage = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - imagesPerView);
        }
    };

    const nextImage = () => {
        if (endIndex < galleryImages.length) {
            setStartIndex(startIndex + imagesPerView);
        }
    };

    return (
        <section className="relative px-6 md:px-20 py-[50px] md:py-[100px] overflow-hidden bg-[#322D2A]">

            <div className="relative z-10 container  px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center relative">
                    {/* Left Side - Main Image */}

                    <div className="hidden lg:block">
                        <div className=" border-[3px] border-orange-500 rounded-[12px] ">
                            <img
                                src={nysc9}
                                alt="NYSC camp"
                                className="w-full h-[550px] object-cover rounded-lg"
                            />
                        </div>
                    </div>

                    {/* Right Side - Content and Thumbnails */}
                    <div className="text-white relative py-10">
                        {/* Header */}
                        <div className="pb-[30px] md:pb-[50px]">
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-8 md:w-16 h-1 bg-[#A4074D]"></div>
                                <span className="">Gallery</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl font-semibold leading-tight">
                                Explore our Gallery across different NYSC Camps
                            </h2>
                        </div>

                        {/* Image Wrapper */}
                        <div className="relative md:absolute md:-left-28 pb-8">
                            <div className="flex gap-2 mb-6 overflow-hidden">
                                {visibleImages.map((image, index) => (
                                    <div
                                        key={image.id}
                                        className="relative group overflow-hidden rounded-lg transition-all duration-300 flex-1"
                                    >
                                        <img
                                            src={image.src || "/placeholder.svg"}
                                            alt="NYSC camp"
                                            className="w-full h-[150px] md:w-[302px] md:h-[212px] object-cover transition-transform duration-300"
                                        />
                                    </div>
                                ))}
                            </div>

                            {/* Navigation Arrows */}
                            <button
                                onClick={prevImage}
                                className="absolute left-2 top-[50%] -translate-y-1/2 bg-white hover:bg-white text-primary-color p-2 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
                                aria-label="Previous image"
                                disabled={startIndex === 0}
                            >
                                <ChevronLeft size={24} />
                            </button>
                            <button
                                onClick={nextImage}
                                className="absolute right-2 top-[50%] -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
                                aria-label="Next image"
                                disabled={endIndex >= galleryImages.length}
                            >
                                <ChevronRight size={24} />
                            </button>

                            {/* Dots Indicator */}
                            <div className="flex justify-center gap-2 mt-4">
                                {Array.from({ length: Math.ceil(galleryImages.length / imagesPerView) }).map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setStartIndex(index * imagesPerView)}
                                        className={`w-2 h-2 rounded-full transition-all duration-300 ${
                                            index === Math.floor(startIndex / imagesPerView)
                                                ? "bg-orange-500 w-6"
                                                : "bg-white/40 hover:bg-white/60"
                                            }`}
                                        aria-label={`Go to image group ${index + 1}`}
                                    ></button>
                                ))}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}